import { TextInput, FormError, Button } from "@components";

export function GroupNameStep({
  control,
  errors,
  onSubmit,
  onCancel,
  submitLabel = "Continue",
  cancelLabel = "Cancel",
}) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      className="p-5 space-y-4"
    >
      <TextInput
        name="name"
        control={control}
        placeholder="Give your group a name"
        required={true}
        errors={errors.name}
        displayName="Group name"
        maxLength={30}
      />
      <FormError name="name" errors={errors} />
      <div className="flex gap-2">
        <Button
          type="button"
          className="shrink-0 rounded-lg"
          onClick={onCancel}
        >
          {cancelLabel}
        </Button>
        <Button
          type="submit"
          color="primary"
          className="shrink-0 grow rounded-lg"
        >
          {submitLabel}
        </Button>
      </div>
    </form>
  );
}
